<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style lang="less">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'helvetica neue', helvetica, 'pingfang sc', 'hiragino sans gb', 'microsoft yahei', '微软雅黑', arial, sans-serif;;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0;
  margin: 0 auto;
}
</style>




// WEBPACK FOOTER //
// src/App.vue